import { DialogConfirmation, spacer16 } from '@spotify-internal/encore-web';
import styled, { css } from 'styled-components';

export const StyledDialogConfirmation = styled(DialogConfirmation)<{
  $hideFooter?: boolean;
}>`
  ${({ $hideFooter }) =>
    $hideFooter &&
    css`
      & > div[class^='Body'] {
        border-bottom: none;
      }
      & > footer {
        display: none;
      }
    `}
`;

export const DialogBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  & > div {
    margin: ${spacer16} 0;
    padding-bottom: 0;
  }
`;
